import React from "react";

import styles from "./DefaultSection.module.scss";
import SectionWrapper from "components/elements/SectionWrapper";

const DefaultSection = ({ title, short_desc, desc, cta_text, cta_link, children }) => {
    return (
        <SectionWrapper className={styles.DefaultSection} title={title} short_desc={short_desc} desc={desc}>
            {children}

        </SectionWrapper>
    );
};

export default DefaultSection;